import React from "react";

const ISettings = ({
  color = "#252526",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M7.875 10.9375C7.875 10.4543 7.48325 10.0625 7 10.0625C6.51675 10.0625 6.125 10.4543 6.125 10.9375C6.125 11.4207 6.51675 11.8125 7 11.8125C7.48325 11.8125 7.875 11.4207 7.875 10.9375ZM8.75 10.9375C8.75 11.904 7.9665 12.6875 7 12.6875C6.0335 12.6875 5.25 11.904 5.25 10.9375C5.25 9.971 6.0335 9.1875 7 9.1875C7.9665 9.1875 8.75 9.971 8.75 10.9375Z"
        fill={color}
      />
      <path
        d="M5.6875 10.9375C5.6875 10.2126 6.27513 9.625 7 9.625C7.72487 9.625 8.3125 10.2126 8.3125 10.9375C8.3125 11.6624 7.72487 12.25 7 12.25C6.27513 12.25 5.6875 11.6624 5.6875 10.9375Z"
        fill={color}
      />
      <path
        d="M7.875 7C7.875 6.51675 7.48325 6.125 7 6.125C6.51675 6.125 6.125 6.51675 6.125 7C6.125 7.48325 6.51675 7.875 7 7.875C7.48325 7.875 7.875 7.48325 7.875 7ZM8.75 7C8.75 7.9665 7.9665 8.75 7 8.75C6.0335 8.75 5.25 7.9665 5.25 7C5.25 6.0335 6.0335 5.25 7 5.25C7.9665 5.25 8.75 6.0335 8.75 7Z"
        fill={color}
      />
      <path
        d="M5.6875 7C5.6875 6.27513 6.27513 5.6875 7 5.6875C7.72487 5.6875 8.3125 6.27513 8.3125 7C8.3125 7.72487 7.72487 8.3125 7 8.3125C6.27513 8.3125 5.6875 7.72487 5.6875 7Z"
        fill={color}
      />
      <path
        d="M7.875 3.0625C7.875 2.57925 7.48325 2.1875 7 2.1875C6.51675 2.1875 6.125 2.57925 6.125 3.0625C6.125 3.54575 6.51675 3.9375 7 3.9375C7.48325 3.9375 7.875 3.54575 7.875 3.0625ZM8.75 3.0625C8.75 4.029 7.9665 4.8125 7 4.8125C6.0335 4.8125 5.25 4.029 5.25 3.0625C5.25 2.096 6.0335 1.3125 7 1.3125C7.9665 1.3125 8.75 2.096 8.75 3.0625Z"
        fill={color}
      />
      <path
        d="M5.6875 3.0625C5.6875 2.33763 6.27513 1.75 7 1.75C7.72487 1.75 8.3125 2.33763 8.3125 3.0625C8.3125 3.78737 7.72487 4.375 7 4.375C6.27513 4.375 5.6875 3.78737 5.6875 3.0625Z"
        fill={color}
      />
    </svg>
  );
};

export default ISettings;
